import { useMemo } from 'react'

import type { MessageAttachment } from '@app/models'

import {
  isFileAttachment,
  isImageMimeType,
} from '../MessageListingAttachments/constants'
import { buildAttachmentId } from '../helpers'
import type { FileAttachmentItem } from '../types'

export type UseImageAttachmentsParams = {
  imageAttachments?: MessageAttachment[]
  attachments?: MessageAttachment[]
}

export const useImageAttachments = ({
  imageAttachments,
  attachments,
}: UseImageAttachmentsParams): FileAttachmentItem[] => {
  return useMemo(() => {
    if (!imageAttachments?.length && !attachments?.length) {
      return [] as FileAttachmentItem[]
    }

    const allImageAttachments = [
      ...(imageAttachments ?? []),
      ...(attachments ?? []),
    ]

    return allImageAttachments
      .filter(isFileAttachment)
      .filter((attachment) => isImageMimeType(attachment.type))
      .reduce<FileAttachmentItem[]>((items, attachment, index) => {
        const exists = items.some((item) => item.url === attachment.url)
        if (exists) {
          return items
        }

        items.push({
          id: buildAttachmentId({
            hash: attachment.hash,
            url: attachment.url,
            index,
          }),
          url: attachment.url,
          name: attachment.name,
          mimeType: attachment.type,
        })

        return items
      }, [])
  }, [attachments, imageAttachments])
}
